import { render, staticRenderFns } from "./OnboardItem.vue?vue&type=template&id=e70ce3de&scoped=true"
import script from "./OnboardItem.vue?vue&type=script&lang=js"
export * from "./OnboardItem.vue?vue&type=script&lang=js"
import style0 from "./OnboardItem.vue?vue&type=style&index=0&id=e70ce3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70ce3de",
  null
  
)

export default component.exports